









































































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { CoolSelect } from 'vue-cool-select';
import { GPageBase } from '@/mixins';
import GStudentFilter from '@/components/GStudentFilter.vue';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import { AddEvalRequest } from '@/models/evalSetting/add-eval-request';
import { EvaluatorStudentProgress } from '@/models/evalSetting/examinee-student-progress';
import { GEnum } from '@/constants/enum.defination';
import { EvaluatorCandidateStudent, EvaluatorCandidateStudentRequest } from '@/models/evalSetting/evaluator-candidate-student';

@Component({
  name: 'GExamDetailProgressAddEvalRequestModal',
  components: { GStudentRecordValueCell, GStudentRecordItemCell, GStudentFilter, CoolSelect },
  computed: {},
  methods: {},
})
export default class GExamDetailProgressAddEvalRequestModal extends Mixins(GPageBase) {
  showModal: boolean = false;
  evaluatorScopeType: GEnum.EvaluatorScopeType = GEnum.EvaluatorScopeType.SameCourseStudents;
  renderKey: number = -1;
  selectedStudentID: number;
  selectedDisplayName: string = '';
  errorMessage: string = '';
  // studentColumns: any[] = [];

  @Prop({ default: false }) value: boolean;
  @Prop({
    default: (): ExamineeStudentProgress[] => {
      return [];
    },
  })
  examinee: ExamineeStudentProgress;

  @Watch('value')
  async openModal(value: boolean) {
    this.evaluatorScopeType = GEnum.EvaluatorScopeType.SameCourseStudents;
    await this.fetchEvaluatorCandidateStudents();
    this.showModal = value;
  }

  @Watch('examinee')
  watchExaminee(value: ExamineeStudentProgress) {
    this.examinee = value;
  }

  @Watch('evaluatorScopeType')
  async watchEvaluatorScopeType(value: GEnum.EvaluatorScopeType) {
    if (!value) return;
    // ラジオボタン変更後に、vue-cool-selectのコンポーネントを強制的に再描画し、選択値をリフレッシュする
    this.renderKey = Math.random();
    this.fetchEvaluatorCandidateStudents();
  }

  async fetchEvaluatorCandidateStudents() {
    const request: EvaluatorCandidateStudentRequest = {
      evalSettingID: evalSettingModule.evalSettingDetail.evalSettingID,
      examineeStudentID: this.examinee.examineeStudentID,
      evaluatorScopeType: this.evaluatorScopeType,
    };
    await evalSettingDetailModule.fetchEvaluatorCandidateStudents(request);
    // 評価者追加後に、vue-cool-selectのコンポーネントが再描画されるようkey値を更新
    this.renderKey = Math.random();
  }

  mounted() {
    // this.studentColumns = [this.columnAction, this.columnStudentNumber, this.columnFullName, this.columnGrade, this.columnSchoolClassName, this.columnTags];
  }

  get radioLabelSameCourseStudents(): GEnum.EvaluatorScopeType {
    return GEnum.EvaluatorScopeType.SameCourseStudents;
  }

  get radioLabelSameSchoolStudents(): GEnum.EvaluatorScopeType {
    return GEnum.EvaluatorScopeType.SameSchoolStudents;
  }

  get noAssignedStudents(): EvaluatorCandidateStudent[] {
    if (this.examinee.evaluatorStudents === undefined) {
      return [];
    }
    return evalSettingDetailModule.evaluatorCandidateStudents;
  }

  get noAssignedStudentDisplayNames(): string[] {
    return this.noAssignedStudents.map((student: EvaluatorCandidateStudent) => student.displayName);
  }

  // vue-cool-select の仕様上、items から1つを選択した場合、
  // displayName の値が v-model で bind される。
  // サーバー側での処理では、studentID を使って処理を行いたいため、displayName => studentID への変換処理を行う
  @Watch('selectedDisplayName')
  watchSelectedDisplayName(newValue: string) {
    this.validate();
    if (newValue === '' || newValue == null) {
      this.selectedStudentID = null;
      return;
    }
    const selected = this.noAssignedStudents.find((student: EvaluatorCandidateStudent) => student.displayName === this.selectedDisplayName);
    this.selectedStudentID = selected.studentID;
  }

  validate() {
    this.errorMessage = !this.selectedDisplayName ? this.$t('NOTICE_NOT_SELECTED_EVALUATOR').toString() : '';
  }

  handleUpdate() {
    const addEvalRequest: AddEvalRequest = {
      evalSettingID: evalSettingModule.evalSettingDetail.evalSettingID,
      examineeStudentID: this.examinee.examineeStudentID,
      evaluatorStudentID: this.selectedStudentID,
    };

    evalSettingModule
      .addEvalRequest(addEvalRequest)
      .then((err: any) => {
        if (err.status === GEnum.HttpStatus.BadRequest) {
          return;
        }
        const evaluator: EvaluatorCandidateStudent = this.noAssignedStudents.find((s: EvaluatorCandidateStudent) => s.studentID === this.selectedStudentID);
        this.examinee.evaluatorStudents.push(
          new EvaluatorStudentProgress().deserialize({
            evaluatorStudentID: evaluator.studentID,
            studentNumber: evaluator.studentNumber,
            schoolClass: evaluator.schoolClass,
            firstName: evaluator.firstName,
            lastName: evaluator.lastName,
            status: GEnum.StatusProgress.NoCompleted,
            giftEvalProgress: GEnum.GiftProgress.NoCompleted,
            freeWordSkillProgress: GEnum.GiftProgress.NoCompleted,
          })
        );

        this.showNotice(GEnum.MessageType.Success, this.$t('ADD_EVALUATOR').toString(), this.$t('MESSAGE_ADD_EVALUATOR', {value1: this.examinee.fullName, value2: evaluator.fullName}).toString(), 10);
        this.$emit('updateTable');
      })
      .finally(() => {
        this.refreshModalSetting();
      });
  }

  handleCancel() {
    this.refreshModalSetting();
  }

  refreshModalSetting() {
    this.selectedStudentID = null;
    this.selectedDisplayName = '';
    this.evaluatorScopeType = null;
    this.errorMessage = '';
    this.$emit('input', false); // モーダルが閉じられたあとでも、再びモーダルを開けるように
  }
  //
  // get columnAction(): any {
  //   return {
  //     title: ' ',
  //     key: 'action',
  //     sortable: 'custom',
  //     slot: 'action',
  //     width: 150,
  //     align: 'center',
  //   };
  // }
  //
  // get columnStudentNumber(): any {
  //   return {
  //     title: this.$t('STUDENT_ID').toString(),
  //     key: 'studentNumber',
  //     sortable: 'custom',
  //     width: 150,
  //     align: 'center',
  //   };
  // }
  //
  // get columnFullName(): any {
  //   return {
  //     title: this.$t('FULL_NAME').toString(),
  //     sortable: 'custom',
  //     slot: 'full-name',
  //     width: 180,
  //     align: 'center',
  //   };
  // }
  //
  // get columnGrade(): any {
  //   return {
  //     title: this.$t('GRADE').toString(),
  //     key: 'grade',
  //     width: 70,
  //     align: 'center',
  //     slot: 'grade',
  //   };
  // }
  //
  // get columnSchoolClassName(): any {
  //   return {
  //     title: this.$t('SCHOOL_CLASS').toString(),
  //     key: 'school-class-name',
  //     align: 'center',
  //     slot: 'school-class-name',
  //   };
  // }
  //
  // get columnTags() {
  //   return {
  //     title: this.$t('TAG').toString(),
  //     width: 300,
  //     key: 'tags',
  //     align: 'center',
  //     slot: 'tags',
  //   };
  // }
}
